import { StyleSheet, Dimensions } from 'react-native'
import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

const { width } = Dimensions.get('window')

const styles = StyleSheet.create({
    modal: {
        justifyContent: 'center',
        alignItems: 'center',
        margin: 0,
        backgroundColor: Colors.blackRGBA(0.2),
    },
    permissionContainer: {
        backgroundColor: Colors.white,
        width: width - 32,
        padding: 16,
        borderRadius: 6,
    },
    permissionButton: {
        alignSelf: 'flex-end',
        paddingVertical: 8,
        paddingHorizontal: 16,
        marginTop: 32,
        borderRadius: 6,
    },
})

export default styles
